<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'ApplicationList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
<!--            <div class="card-header">-->
<!--              <h4 class="card-title">{{$t('views.application.create.title')}}</h4>-->
<!--            </div>-->
            <template v-if="isLoading">
              <Loader></Loader>
            </template>
            <template v-else>
              <div class="card-body">
                <ApplicationForm
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :generate-connection-key="generateConnectionKey"
                  :errors="violations" />
              </div>
            </template>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ApplicationForm from './Form'
import Loader from '../../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('application/create')

export default {
  components: {
    Loader,
    ApplicationForm
  },

  data () {
    return {
      item: {
        databaseConnection: undefined,
        databaseImportFile: undefined,
        createNewInstance: true,
        confirmationCreatingSubdomain: false,
        connectionKey: ''
      }
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'ApplicationUpdate', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    generateConnectionKey (bytes = 20) {
      let crypto = require('crypto')
      this.item.connectionKey = crypto.randomBytes(bytes).toString('hex')
    },

    onSendForm () {
      if (this.item.SwiftmailerPort) {
        this.item.SwiftmailerPort = parseInt(this.item.SwiftmailerPort)
      }
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
